/// <amd-module name="SuiteCommerce.ItemRecSys.WidgetCct"/>
define("SuiteCommerce.ItemRecSys.WidgetCct", ["require", "exports", "SuiteCommerce.ItemRecSys.Instrumentation.Logger", "SuiteCommerce.ItemRecSys.WidgetCctView"], function (require, exports, Logger_1, WidgetCctView_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WidgetCct = void 0;
    exports.WidgetCct = {
        mountToApp: function (container) {
            Logger_1.Logger.initializeEnvironment(container);
            this.registerCCT(container);
        },
        registerCCT: function (container) {
            var cmsComponent = container.getComponent('CMS');
            cmsComponent.registerCustomContentType({
                id: 'cct_ns_recsys_widget',
                // FIXME
                // @ts-ignore
                view: WidgetCctView_1.WidgetCctView,
                options: {
                    container: container,
                },
            });
        },
    };
});
